module.exports = __webpack_public_path__ + "static/media/az.2c050549.svg";